import React, { Fragment } from "react";
import Root from "./Root";
import ReactDOM from "react-dom/client";
import store from "./app/store";
import reportWebVitals from "./reportWebVitals";
import setupAxios from "./app/config/axios";
import "overlayscrollbars/overlayscrollbars.css";
import "./index.scss";

const root: any = ReactDOM.createRoot(
  document.getElementById("root") || document.createElement("div"),
);

setupAxios();

const AppContainer = Fragment;

root.render(
  <AppContainer>
    <Root store={store} />
  </AppContainer>,
);

reportWebVitals();
